
import React from 'react';
import Navbar from '@/components/Navbar';
import CTASection from '@/components/CTASection';
import HeroSection from '@/components/about/HeroSection';
import StorySection from '@/components/about/StorySection';
import TimelineSection from '@/components/about/TimelineSection';
import ImpactSection from '@/components/about/ImpactSection';
import MissionSection from '@/components/about/MissionSection';

import ValuesSection from '@/components/about/ValuesSection';
import TestimonialsSection from '@/components/about/TestimonialsSection';
import PartnersSection from '@/components/about/PartnersSection';
import SEOMetadata from '@/components/about/SEOMetadata';
import Breadcrumb from '@/components/Breadcrumb';
import QuickNav from '@/components/about/QuickNav';
import { useEffect } from 'react';
import TelemarketingScanCTA from '@/components/TelemarketingScanCTA';
import { useLocation } from 'react-router-dom';

const OverOns = () => {
  const location = useLocation();
  
  // Track page view for analytics
  useEffect(() => {
    console.log("Over Ons page viewed");
    // Here you would normally add your analytics tracking code
  }, []);

  // Handle scrolling based on location state or hash
  useEffect(() => {
    const scrollToSection = () => {
      // Check if we have a section to scroll to from state (from programmatic navigation)
      const sectionId = location.state?.scrollToSection;
      
      // If we have a section from state or from hash
      const targetSection = sectionId || (location.hash ? location.hash.substring(1) : null);
      
      if (targetSection) {
        // Use setTimeout to ensure DOM is fully rendered
        setTimeout(() => {
          const element = document.getElementById(targetSection);
          if (element) {
            const yOffset = -80; // Adjust based on header height
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
            console.log(`Scrolling to ${targetSection} section`);
          }
        }, 600); // Slightly longer delay to ensure DOM is ready
      }
    };
    
    // Execute scrolling logic
    scrollToSection();
    
  }, [location]); // Re-run when location changes

  return (
    <div className="min-h-screen flex flex-col">
      <SEOMetadata />
      <Navbar />
      
      <main id="main-content" className="flex-grow">
        <Breadcrumb />
        <HeroSection />
        <QuickNav />
        
        <div id="story">
          <StorySection />
        </div>
        <div id="timeline">
          <TimelineSection />
        </div>
        <div id="impact">
          <ImpactSection />
        </div>
        <div id="mission">
          <MissionSection />
        </div>
        
        {/* Telemarketing Scan CTA Banner - Positioned at the same place as on homepage */}
        <TelemarketingScanCTA />
        
        <div id="values">
          <ValuesSection />
        </div>
        <TestimonialsSection />
        <PartnersSection />
      </main>
      
      <CTASection />
      {/* Footer removed as it's already included by PageContainer */}
    </div>
  );
};

export default OverOns;
